import { render } from "./NutrableProgram.vue?vue&type=template&id=81881744"
import script from "./NutrableProgram.vue?vue&type=script&lang=js"
export * from "./NutrableProgram.vue?vue&type=script&lang=js"

import "./NutrableProgram.vue?vue&type=style&index=0&id=81881744&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__